import { render, staticRenderFns } from "./VehiclesCRUD.vue?vue&type=template&id=b74559f8&"
import script from "./VehiclesCRUD.vue?vue&type=script&lang=js&"
export * from "./VehiclesCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports